import {
  type CsatLanguageCode,
  type CsatLanguageName,
  csatLanguages as supportedCsatLanguages,
} from 'lib-shared-languages';

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export type SupportedCSATLanguageCode = CsatLanguageCode;

/**
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export type SupportedCSATLanguage = {
  code: CsatLanguageCode;
  label: CsatLanguageName;
};

/**
 * The list of supported languages specifically for Email CSAT and Phone-SMS
 * CSAT settings.
 * @deprecated Use an appropriate language export from `lib-shared-languages` instead.
 */
export const csatLanguages: ReadonlyArray<SupportedCSATLanguage> =
  supportedCsatLanguages.map(({ code, name }) => ({ code, label: name }));
